import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ftp: [],
  loading: false,
  error: null,
};

const ftpSlice = createSlice({
  name: "ftp",
  initialState,
  reducers: {
    setFtp: (state, action) => {
      state.ftp = action.payload;
      state.loading = false;
      state.error = null;
    },
    setFtpLoading: (state, action) => {
      state.loading = action.payload;
    },
    setFtpError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearFtpError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setFtp,
  setFtpLoading,
  setFtpError,
  clearFtpError,
} = ftpSlice.actions;

// Selectors - Direct access to FTP state
export const selectFtp = (state) => state.ftp?.ftp || [];
export const selectFtpLoading = (state) => state.ftp?.loading || false;
export const selectFtpError = (state) => state.ftp?.error || null;

export default ftpSlice.reducer;
